<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <div class="width-full m-display-flex space-between">
        <div>
          <a-icon type="wallet" class="margin-right-small" />
          Cooperative Deduction List
        </div>
        <a-button type="primary" icon="plus" @click="toCreate">Add Deduction</a-button>
      </div>
    </div>
    <div class="wrapper-body">
      <a-row :gutter="16">
        <a-col :xs="{ span: 24 }" :lg="{ span: 21 }">
          <a-input-search v-model="search" placeholder="Quick Search" />
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
          <a-button
            :class="getScreen ? 'margin-top' : ''"
            block
            :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
            @click="handleshowMore"
            >{{
              advancedsearch == "display:none" ? "More" : "Less"
            }}</a-button
          >
        </a-col>
      </a-row>
      <a-row :style="advancedsearch" :gutter="16" class="margin-top">
        <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
          <div class="m-form-item-wrapper">
            <label>Status</label>
            <a-radio-group default-value="all" v-model="filter.status">
              <a-radio value="all">
                ALL
              </a-radio>
              <a-radio value="Open">
                <a-tag color="green">OPEN</a-tag>
              </a-radio>
              <a-radio value="Close">
                <a-tag color="red">CLOSE</a-tag>
              </a-radio>
            </a-radio-group>
          </div>
        </a-col>
      </a-row>
      <a-config-provider :locale="getLocalConfigProvider()">
        <a-table 
          class="cdl margin-top"
          bordered :columns="columns" 
          :data-source="datasource.data" size="small" 
          :pagination="pagination" 
          :rowKey="(record, index) => {
            return index;
          }" :loading="loading.table"
        >
          <template slot="periode" slot-scope="item">
            {{ moment(item.periode,'YYYY-MM').format('MMMM-YYYY') }}
          </template>
          <template slot="description" slot-scope="item">
            {{ item.description }}
          </template>
          <template slot="total" slot-scope="item">
            <CurrencyJustified
              :currencyValue="'IDR'"
              :valueNumber="item.total"
            />
          </template>
          <template slot="cdtlc" slot-scope="item">
            {{ moment(item.tgl_buat,'YYYY-MM-DD').format('DD-MM-YYYY') }} | {{ item.create_by }}
          </template>
          <template slot="sts" slot-scope="item">
            <a-tag :color="item.status_label=='Open'? 'green' : 'red'">{{ item.status_label.toUpperCase() }}</a-tag>
          </template>
          <template slot="aksi" slot-scope="item">
            <a-button icon="eye" type="primary" @click="toManifest(item.id_potongan)"/>
          </template>
        </a-table>
      </a-config-provider>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "cooperative-deduction",
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    return {
      search: "",
      advancedsearch: "display:none",
      loading: {
        table: false
      },
      filter:{
        status: "all"
      },
      datasource: {
        data: [],
        dataOriginal: []
      },
       pagination: {
        onChange: (page) => {},
        pageSize: 10,
        size: "small",
      },
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAllMataUang",
      "getAllKaryawan",
    ]),
    columns() {
      const columns = [
        {
          title: "period",
          key: "periode",
          scopedSlots: { customRender: "periode" },
          width: "150px",
        },
        {
          title: "description",
          key: "description",
          scopedSlots: { customRender: "description" },
          width: "auto",
        },
        {
          title: "total",
          key: "total",
          scopedSlots: { customRender: "total" },
          width: "200px",
        },
        {
          title: "Create | TLC",
          key: "cdtlc",
          scopedSlots: { customRender: "cdtlc" },
          align: "center",
          width: "150px",
        },
        {
          title: "Status",
          key: "sts",
          scopedSlots: { customRender: "sts" },
          align: "center",
          width: "100px",
        },
        {
          title: "ACTION",
          key: "aksi",
          scopedSlots: { customRender: "aksi" },
          align: "center",
          fixed: "right",
          width: "75px",
        },
      ]
      return columns
    }
  },
  mounted(){
    this.fetchData()
  },
  methods:{
    moment,
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },
    toCreate(){
      this.$router.push({
        name: "cooperativeDeductionCreate",
        params: {},
      });
    },
    fetchData(){
      this.loading.table = true;
      this.asyncAxiosGet("potongan_koperasi",
        this.getAuth,
        {}
      )
      .then(
        (res) => {
          this.datasource.data = res.data;
          this.datasource.data.forEach(element => {
            element.Qsearch = moment(element.periode,'YYYY-MM').format('MMMM-YYYY').toLowerCase() + 
              element.description.toLowerCase() + 
              moment(element.tgl_buat,'YYYY-MM-DD').format('DD-MM-YYYY') +
              element.create_by.toLowerCase() + 
              element.status_label.toLowerCase()
          });
          this.datasource.dataOriginal = this.datasource.data
          this.loading.table = false;
        })
        .catch((error) => {
          let responses = Object.assign({}, error);
          if (responses.response.data) {
            this.displayMessageValue(
              "error-other",
              responses.response.data.message
            );
          } else {
            this.displayMessageValue("error-other", responses.response);
          }
          this.loading.table = false;
        }
      );
    },
    searching(){
      let result = this.datasource.dataOriginal
      if(this.search){
        result = result.filter(item => item.Qsearch.indexOf(this.search.toLowerCase()) >=0 )
      }

      if(this.filter.status && this.filter.status!='all'){
        result = result.filter(item => item.status_label==this.filter.status)
      }

      this.datasource.data = result
    },
    toManifest(id){
      this.$router.push({
        name: "cooperativeDeductionManifest",
        params: { id:id },
      });
    }
  },
  watch:{
    search(){
      this.searching()
    },
    "filter.status"(){
      this.searching()
    }
  }
}
</script>
<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);
  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 15px !important;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}

.result {
  margin: @padding 0;
  display: flex;
  justify-content: space-between;
}

.cdl:deep {
  .ant-table-body{
    thead {
      th {
        text-transform: uppercase;
        text-align: center;
      }
    }
  }
}
</style>